import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {IAppConfig, IAppState} from "../../store/interfaces/index";
import {NgRedux} from "@angular-redux/store";
import {useDefault} from "../common";
import {DateUtils} from "../date.utils";

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;

enum DateActions {
  CheckInClick = 1,
  CheckOutClick = 2
}

export class DateRangeCommon implements OnInit {
  public _startDate: Date;
  public _endDate: Date;
  @Input() messages;
  @Output() onSelectStartDate: EventEmitter<Date>;
  @Output() onSelectEndDate: EventEmitter<Date>;
  public showCalendar: boolean;
  public hoveredDate: NgbDateStruct;
  public availableReservation: boolean;
  public actualDate: Date;
  public maxDate: Date;
  public minMappedDate: NgbDateStruct;
  public maxMappedDate: NgbDateStruct;
  public startCalendarDate: any;
  public order: number;
  public firstDayOfWeek: number;
  public dateActions: any;

  public _startDateStruct: NgbDateStruct;
  public _endDateStruct: NgbDateStruct;
  public state: IAppState;

  public model: NgbDateStruct;
  constructor(private appConfig: IAppConfig,
              private _ngRedux: NgRedux<IAppState>) {
    this.onSelectStartDate = new EventEmitter<Date>();
    this.onSelectEndDate = new EventEmitter<Date>();
  }

  ngOnInit() {
    this.updateFromState();
    this._ngRedux.subscribe( () => {
      this.updateFromState();
    });
    this.dateActions = DateActions;
    this.firstDayOfWeek = DateUtils.resolveCalendarStartingDay(this.appConfig);
    this.order = this.dateActions.CheckInClick;
    this.showCalendar = false;
    this.actualDate = new Date();
    this.maxDate = new Date();
  }

  get startDate(): Date {
    return this._startDate;
  }
  @Input()
  set startDate(value: Date) {
    if (!value) { return; }
    this._startDate = value;
    this._startDateStruct = this.toStruct(this._startDate);
  }

  get endDate(): Date {
    return this._endDate;
  }
  @Input()
  set endDate(value: Date) {
    if (!value) { return; }
    this._endDate = value;
    this._endDateStruct = this.toStruct(this._endDate);
  }

  onDateChange(date: NgbDateStruct) {
    if (!this._startDateStruct && !this._endDateStruct) {
      this._selectStartDate(date);
      this.order = DateActions.CheckOutClick;
    } else if (this._startDateStruct && !this._endDateStruct && after(date, this._startDateStruct)) {
      this._selectEndDate(date);
      this.showCalendar = false;
    } else if (this._startDateStruct && this._endDateStruct && this.order === DateActions.CheckOutClick) {
      if (!equals(this._startDateStruct, date)) {
        this._selectEndDate(date);
        this.showCalendar = false;
      }
    } else if (this._startDateStruct && this._endDateStruct && this.order === DateActions.CheckInClick && before(date, this._endDateStruct)) {
      this._selectStartDate(date);
      this.showCalendar = false;
    }  else if (this._startDateStruct && this._endDateStruct && this.order === DateActions.CheckInClick && before(this._endDateStruct, date)) {
      this._selectStartDate(date);
      let tempDate = new Date(this.startDate);
      tempDate.setDate(this.fromStruct(date).getDate() + 1);
      this._selectEndDate(this.toStruct(tempDate));
      this.minMappedDate = this._startDateStruct;
      this.order = DateActions.CheckOutClick;
    } else {
      this._endDateStruct = null;
      this._selectStartDate(date);
      this.minMappedDate = this._startDateStruct;
      this.order = DateActions.CheckOutClick;
    }
  }

  private _selectStartDate(date: NgbDateStruct) {
    this.startDate = this.fromStruct(date);
    this.onSelectStartDate.emit(this.startDate);
  }
  private _selectEndDate(date: NgbDateStruct) {
    this.endDate = this.fromStruct(date);
    this.onSelectEndDate.emit(this.endDate);
  }

  closeCalendar(e: Event) {
    if (this.order === DateActions.CheckOutClick && this._endDateStruct === null && this.startDate) {
      let tempDate = new Date(this.startDate);
      tempDate.setDate(tempDate.getDate() + 1);
      this._selectEndDate(this.toStruct(tempDate));
    }
    this.showCalendar = false;
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    this.availableReservation = !!this.state.availableReservation;
  }

  isHovered = date => this._startDateStruct && !this._endDateStruct && this.hoveredDate && after(date, this._startDateStruct) && before(date, this.hoveredDate);
  isInside = date => after(date, this._startDateStruct) && before(date, this._endDateStruct);
  isFrom = date => equals(date, this._startDateStruct);
  isTo = date => equals(date, this._endDateStruct);
  toStruct = (date: Date) => <NgbDateStruct>{ day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear()};
  toDate = (value) => new Date(useDefault(value, null));
  fromStruct = (struct: NgbDateStruct) => new Date(struct.year, struct.month - 1, struct.day);
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/date-range/date-range.common.ts